var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"ic_close_24px","d":"M57.119,10.249,51.87,5,31.06,25.81,10.249,5,5,10.249,25.81,31.06,5,51.87l5.249,5.249,20.81-20.81,20.81,20.81,5.249-5.249L36.309,31.06Z","transform":"translate(11 11)"}));
}

CloseInline.defaultProps = {"width":"52.119","height":"52.119","viewBox":"0 0 85.119 85.119"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
